import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import logo from "./zef-logo.png";
import "../App/App.css";
import "./Header.css";

class Header extends Component {
  constructor() {
    super();

    this.signOut = this.signOut.bind(this);
  }

  signOut() {
    this.props.onSignedOut();
  }

  render() {
    const { tag } = this.context;

    return (
      <header className="header" role="banner">
        <nav className="header-container">
          <Link to="/">
            <img className="header-logo" src={logo} alt="Home" />
          </Link>
          {this.context.isSignedIn && (
            <div className="header-panel-logged-in">
              <span className="header-username">{tag}</span>
              <button
                className="header-link button-link"
                onClick={this.signOut}
              >
                Cerrar sesión
              </button>
            </div>
          )}
          {!this.context.isSignedIn && (
            <Link className="header-link" to="/ingresar">
              Iniciar sesión
            </Link>
          )}
        </nav>
      </header>
    );
  }
}

Header.contextTypes = {
  isSignedIn: PropTypes.bool,
  tag: PropTypes.string
};

Header.propTypes = {
  onSignedOut: PropTypes.func
};

export default Header;



// WEBPACK FOOTER //
// ./src/Header/Header.js